var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { useState } from 'react';
/**
 * `useSelectedState` is a hook that provides an API to manage an arbitrary
 * array f objects. Optionally providing timeouts or automated propagation of
 * any changes to the view.
 *
 * By default changes are automatically propagated to the view after 1000ms (1s)
 *
 * @param initial An initial list of objects to be selected
 * @param idKey The key of the object that's being selected
 */
export function useSelectedState(initial, idKey) {
    var _a = useState(initial), selected = _a[0], setSelected = _a[1];
    var _b = useState(initial), propagated = _b[0], setPropagated = _b[1];
    function remove(item) {
        setSelected(selected.filter(function (curr) { return curr[idKey] !== item[idKey]; }));
    }
    function propagate() {
        setPropagated(selected);
    }
    function add(item) {
        setSelected(__spreadArray(__spreadArray([], selected), [item]));
    }
    function selectRemaining(remaining) {
        var all = __spreadArray(__spreadArray([], selected), remaining);
        setSelected(all);
        setPropagated(all);
    }
    function clear() {
        setSelected([]);
        setPropagated([]);
    }
    return {
        add: add,
        clear: clear,
        remove: remove,
        selectRemaining: selectRemaining,
        propagate: propagate,
        propagated: propagated,
        selected: selected
    };
}
//# sourceMappingURL=useSelectedState.js.map